import React, { Component } from "react";
import WidgetPageRenderer from "../widgets/WidgetPageRenderer";

import LoadingOverlay from "./LoadingOverlay";
export default class Widget_library_categories_NEW extends Component {
  render() {
    return <WidgetPageRenderer pageRoute="widget_library_categories" />;
  }
}
